/* global femcare, axios */

/**
 * Mock API interceptor for local development.
 *
 * When the app is served on localhost (e.g. via BrowserSync), this module
 * intercepts outgoing Axios and jQuery AJAX requests and redirects them
 * to local JSON mock files in /json/mock-api/.
 */
femcare.mock.api = {

    /**
     * Maps URL fragments to local JSON mock files.
     * The pattern is matched against the request URL using String.includes().
     */
    MOCK_ROUTES: [
        { pattern: 'ajax/core/shared/generatetoken', file: 'generate-token.json' },
        { pattern: 'ajax/products/product/updateBagItem', file: 'update-bag-item.json' },
        { pattern: 'ajax/products/product/addItemToBag', file: 'add-item-to-bag.json' },
        { pattern: 'ajax/products/product/detailproductsku', file: 'detail-product-sku.json' },
        { pattern: 'ajax/products/product/notifyMe', file: 'notify-me.json' },
        { pattern: 'ajax/products/product/getbag?onlyTotal', file: 'get-bag-total.json' },
        { pattern: 'ajax/products/product/getbag', file: 'get-bag.json' },
        { pattern: 'ajax/core/customsearch/suggest', file: 'customsearch-autocomplete.json' }
    ],

    /**
     * Base path where mock JSON files are served during local development.
     */
    MOCK_BASE_PATH: '/json/mock-api/',

    /**
     * Initializes mock API interceptors if running on localhost.
     */
    init() {
        if (!this.isLocalDevelopment()) {
            return;
        }

        this.registerAxiosInterceptor();
        this.registerJQueryAjaxPrefilter();

        console.info('[Mock API] Local development detected - API requests will be served from local JSON files.');
    },

    /**
     * Determines whether the app is running on a local development server.
     *
     * @returns {boolean}
     */
    isLocalDevelopment() {
        const { hostname } = window.location;

        return hostname === 'localhost' || hostname === '127.0.0.1';
    },

    /**
     * Finds the mock file for a given URL.
     *
     * @param {string} url - The request URL to match.
     * @returns {string|null} - The local file path, or null if no match.
     */
    findMockFile(url) {
        const route = this.MOCK_ROUTES.find(({ pattern }) => url.includes(pattern));

        return route ? this.MOCK_BASE_PATH + route.file : null;
    },

    /**
     * Registers an Axios request interceptor that redirects matching
     * requests to local JSON mock files.
     */
    registerAxiosInterceptor() {
        axios.interceptors.request.use((config) => {
            const mockFile = this.findMockFile(config.url);

            if (mockFile) {
                config.url = mockFile;
                config.method = 'get';
                delete config.data;
                config.headers = {};
            }

            return config;
        });
    },

    /**
     * Registers a jQuery $.ajaxPrefilter that redirects matching
     * requests to local JSON mock files.
     */
    registerJQueryAjaxPrefilter() {
        $.ajaxPrefilter((options) => {
            const mockFile = this.findMockFile(options.url);

            if (mockFile) {
                options.url = mockFile;
                options.type = 'GET';
                options.data = null;
                options.contentType = 'application/json';
                options.headers = {};
            }
        });
    }
};
